import zod from 'zod';

export const createTagSchema = zod.object({
  Name: zod.string().min(1, { message: 'Tag name is required.' }),
});
